__turbopack_context__.v({
  "content": "styles-module-scss-module__z-uqha__content",
  "main": "styles-module-scss-module__z-uqha__main",
});
